export default /* glsl */`
mat3 rotationMat(float aRad) {
    float cosA = cos(aRad);
    float sinA = sin(aRad);
    return mat3(
        cosA, -sinA, 0.0,
        sinA, cosA, 0.0,
        0.0, 0.0, 1.0
    );
}
`;
